import React, { PropsWithChildren } from 'react';
import Rating from '@material-ui/lab/Rating';
import { JigsawComponent } from '../../theme/system';
import { RatingProps } from '@material-ui/lab/Rating';
import { gray } from '../../theme/colors';
import StarIcon from '../../icons/Star';
import styled from 'styled-components';

type StarRatingProps = PropsWithChildren<JigsawComponent> & RatingProps;

const StyledStarRatingHolder = styled.div`
  line-height: 0;
  & .MuiRating-root {
    font-size: 28px;
  }

  & .MuiRating-sizeSmall {
    font-size: 24px;
  }

  & .MuiRating-sizeLarge {
    font-size: 32px;
  }
`;

const StarRating = ({ size = 'small', ...props }: StarRatingProps) => {
  return (
    <StyledStarRatingHolder>
      <Rating
        emptyIcon={<StarIcon htmlColor={gray['200']} fontSize="inherit" />}
        icon={<StarIcon fontSize="inherit" />}
        size={size}
        precision={0.1}
        {...props}
      />
    </StyledStarRatingHolder>
  );
};

StarRating.displayName = 'StarRating';
export default StarRating;
